import {Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from 'typeorm';
import { Departments } from 'apps/services/masters/src/app/departments/departments.entity';
import { FgStatusEnum } from "@gtpl/shared-models/common-models";


@Entity('suggestions')
export class Suggestions{

    @PrimaryGeneratedColumn('increment', {name: 'suggestion_id'})
    suggestionId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'suggestion_name'
    })
    suggestion: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'suggestion_type'
    })
    suggestionType: string;

    @Column("int", {
        nullable: false,
        name: "department_id"
      })
      departmentId: number;

      @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'department_name'
    })
    departmentName: string;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'remarks'
    })
    remarks: string;

    @Column({
        type: 'enum',
        enum: FgStatusEnum,
        nullable: false,
        default: FgStatusEnum.OPEN,
        name: 'status'
    })
    status: FgStatusEnum;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('varchar', {
        // nullable: false,
        length: 40,
        name: 'employeeName'

    })
    employeeName: string;

    // @ManyToOne(type=> Departments, department => department.suggestionsInfo, {nullable: true})
    // @JoinColumn({name: 'dept_id'})
    // department: Departments;
}